import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useStores } from 'index';
import { Profile } from 'types/StartupTypes';

export const useGetConfig = () => {
  const startupService = useStores().startupService;

  return useQuery({
    queryKey: ['getConfig'],
    queryFn: () => startupService.getConfigs(),
  });
};

export const useGetApps = () => {
  const startupService = useStores().startupService;
  const { identityUrl } = useStores().me;

  return useQuery({
    queryKey: ['getApps'],
    queryFn: () => startupService.getAllApps(identityUrl),
  });
};

export const useGetProfile = () => {
  const startupService = useStores().startupService;

  return useQuery({
    queryKey: ['getProfile'],
    queryFn: () => startupService.getProfile(),
  });
};

export const useGetProfileCache = (): Profile | undefined => {
  return useQueryClient().getQueryData(['getProfile']);
};

export const useGetPermissions = () => {
  const startupService = useStores().startupService;

  return useQuery({
    queryKey: ['getPermissions'],
    queryFn: () => startupService.getPermissions(),
  });
};

export const useIsLoadingStartupData = () => {
  const { isLoading: isLoadingConfig } = useGetConfig();
  const { isLoading: isLoadingApps } = useGetApps();
  const { isLoading: isLoadingProfile } = useGetProfile();
  //   const { isLoading: isLoadingPermissions } = useGetPermissions(); // Permissions are obtained from the berarer token in this app

  return isLoadingConfig || isLoadingApps || isLoadingProfile;
};
